import React from 'react';
import { X } from 'lucide-react';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../mock';
import zoopersLogo from '../../assets/logo_website.png';

export default function BookingModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-3xl shadow-2xl p-8 max-w-sm w-full animate-fadeUp">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 h-8 w-8 grid place-items-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
        >
          <X size={16} />
        </button>
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <img src={zoopersLogo} alt="Zoopers" className="h-12 w-auto object-contain" />
          </div>
          <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: "'Poppins', sans-serif" }}>Book via Zoopers App</h2>
          <p className="mt-2 text-sm text-slate-500">Download the Zoopers app to schedule a pickup, track orders, and get doorstep service.</p>
        </div>
        <div className="mt-6 flex flex-col gap-3">
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-[#12121A] hover:bg-slate-800 text-white rounded-2xl px-5 py-3.5 transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76a2.07 2.07 0 0 0 .47.24l10.3-10.3-2.97-2.97L3.18 23.76zM20.52 10.4l-2.8-1.6-3.35 3.22 3.35 3.35 2.8-1.62a2.09 2.09 0 0 0 0-3.35zM3 .24a2.09 2.09 0 0 0-.47.24L10.98 9l2.97-2.97L3 .24zM14.25 12 3.65 22.6a2 2 0 0 0 1.2-.2l11.73-6.78-2.33-2.62z"/></svg>
            <span className="text-sm font-semibold">Get it on Google Play</span>
          </a>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-[#12121A] hover:bg-slate-800 text-white rounded-2xl px-5 py-3.5 transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            <span className="text-sm font-semibold">Download on App Store</span>
          </a>
        </div>
      </div>
    </div>
  );
}
